// C:\Users\Ahmed Ali\Desktop\FYP project\Shyra.net\DeveloperFolio-master\src\blogs\index.js

import Blog1 from "./1-The-Definitive-Guide-to-Facebook-Crypto-Ads-in-2026";
import Blog2 from "./2-Mastering-Crypto-AMA-Guide-2026";
import Blog3 from "./3-Ultimate-Guide-to-Crypto-Keywords-2026";
import Blog4 from "./4-Crypto-Advertising-Agency-Guide-2026";
import Blog5 from "./5-Strategic-Discord-Moderation-Guide-2026";
import Blog6 from "./6-Community-as-Infrastructure-Discord-Growth-Guide-2026";
import Blog7 from "./7-How-to-Promote-Your-Discord-Server-Guide-2026";  // ADD THIS
import Blog8 from "./8-100-Creative-Discord-Channel-Ideas-Guide-2026";  // ADD THIS
import Blog9 from "./9-Web3-Community-Growth-Mastering-Crypto-Marketing-Strategies-2026";  // ADD THIS


import firstBlogImage from "./images/1stbblog.jfif";
import secondBlogImage from "./images/2ndbblog.jfif";
import thirdBlogImage from "./images/3rdbblog.jfif";
import fourthBlogImage from "./images/4thblogimage.png";
import fifthBlogImage from "./images/5thblogimage.jfif";
import sixthBlogImage from "./images/6thblog.jfif";
import seventhBlogImage from "./images/7thblogimage.jpeg";  // ADD THIS
import eighthBlogImage from "./images/8thblogimage.jpeg";  // ADD THIS

import ninthBlogImage from "./images/9thblogimage.jpeg";  // ADD THIS


export const blogs = [
  {
    id: 1,
    slug: "facebook-crypto-ads-guide-2026",
    title: "The Definitive Guide to Facebook Crypto Ads in 2026: Master Meta's Policies, Approval, and High-Performance Growth Strategies",
    excerpt: "Navigating the landscape of crypto paid advertising strategies has become one of the most significant challenges for founders in the digital asset space...",
    date: "April 15, 2026",
    image: firstBlogImage,
    component: Blog1
  },
  {
    id: 2,
    slug: "mastering-crypto-ama-guide-2026",
    title: "Mastering the Crypto AMA: The Ultimate 2026 Guide to Community Trust, Viral Growth, and Web3 Marketing Excellence",
    excerpt: "In an industry where decentralization is the core philosophy but trust is the hardest currency to earn, the AMA session has evolved from a simple Q&A into a sophisticated pillar...",
    date: "April 20, 2026",
    image: secondBlogImage,
    component: Blog2
  },
  {
    id: 3,
    slug: "ultimate-guide-to-crypto-keywords-2026",
    title: "The Ultimate 2026 Guide to Crypto Keywords: Mastering SEO and PPC for Web3 Dominance",
    excerpt: "In the rapidly shifting landscape of 2026, where DeFi, NFTs, and the broader metaverse have moved from fringes to mainstream, the competition for digital visibility has reached an all-time high...",
    date: "April 25, 2026",
    image: thirdBlogImage,
    component: Blog3
  },
  {
    id: 4,
    slug: "crypto-advertising-agency-guide-2026",
    title: "The 2026 Crypto Advertising Ecosystem: Regulatory Compliance and Agency Performance",
    excerpt: "Market analysis from early 2026 indicates that Google has rejected more than 40% of cryptocurrency-related ad submissions. Discover which agencies can help you navigate MiCA, FCA, and platform compliance...",
    date: "April 29, 2026",
    image: fourthBlogImage,
    component: Blog4
  },
  {
    id: 5,
    slug: "strategic-discord-moderation-guide-2026",
    title: "Strategic Discord Moderation: A Framework for Web3 Community Management in 2026",
    excerpt: "With 690 million registered users and 1.1 billion messages processed daily, Discord is the frontline of Web3 community trust. Learn how to build a professional moderation framework...",
    date: "April 29, 2026",
    image: fifthBlogImage,
    component: Blog5
  },{
    id: 6,
    slug: "community-as-infrastructure-discord-growth-guide-2026",
    title: "Community as Infrastructure: A Strategic Guide to Discord Growth in 2026",
    excerpt: "Discord boasts over 259.2 million monthly active users. Learn how to build server architecture, integrate bots, leverage KOL partnerships, and measure retention for Web3 success...",
    date: "April 29, 2026",
    image: sixthBlogImage,
    component: Blog6
  },  {
    id: 7,  // ADD THIS ENTIRE OBJECT
    slug: "how-to-promote-discord-server-guide-2026",
    title: "How to Promote Your Discord Server: Building a High-Growth Web3 Community in 2026",
    excerpt: "With 259.2 million monthly active users and over 32.6 million servers, discover 10 proven strategies to promote your Discord server using influencer marketing, KOL partnerships, bots, and Web3 growth tactics...",
    date: "May 3, 2026",
    image: seventhBlogImage,
    component: Blog7
  },
    {
    id: 8,  // ADD THIS ENTIRE OBJECT
    slug: "100-creative-discord-channel-ideas-guide-2026",
    title: "100 Creative Discord Channel Ideas: The Ultimate 2026 Guide to Building a Strong Crypto Community",
    excerpt: "Discover 100 creative Discord channel ideas for Web3 crypto communities. Learn strategic channel architecture, engagement tactics, retention strategies, and how to build a strong crypto community that scales.",
    date: "May 3, 2026",
    image: eighthBlogImage,
    component: Blog8
  },
   {
    id: 9,  // ADD THIS ENTIRE OBJECT
    slug: "web3-community-growth-mastering-crypto-marketing-strategies-2026",
    title: "The Ultimate 2026 Guide to Web3 Community Growth: Mastering Crypto Marketing Strategies",
    excerpt: "Master Web3 community growth in 2026 with proven crypto marketing strategies. Learn Telegram, Discord, Twitter marketing, KOL management, SEO, PR, and community building.",
    date: "May 4, 2026",
    image: ninthBlogImage,
    component: Blog9
  },
];